import config from '@/config/config';
import { del, get, patch, post, put } from '@/helpers/api.helper';
export const getChatShortLink = async (userId: string, productGroupId: string) => {
    return get(`/users/${userId}/short-link?mallProductGroupId=${productGroupId}`, { baseURL: config.api.chat2_api });
};
export const createChatShortLinkByProductGroupId = async ({
    userId,
    productGroupId,
}: {
    userId: string;
    productGroupId: string;
}) => {
    return get(`/users/${userId}/short-link?mallProductGroupId=${productGroupId}`, { baseURL: config.api.chat2_api });
};
export const createChatShortLinkByVendorId = async ({ userId, vendorId }: { userId: string; vendorId: string }) => {
    return get(`/users/${userId}/short-link?vendorId=${vendorId}`, { baseURL: config.api.chat2_api });
};
